import mailVistaLogo from "@/assets/icons/mailvista-logo.svg";
import Ellipse from "@/assets/style/Ellipse.svg";
import { Button } from "@/components/ui/button";
import authStore from "@/stores/authStore";
import { useStore } from "@tanstack/react-store";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const AskConsent = () => {
    const hasBeenRedirectedToConsent = useStore(
        authStore,
        (state) => state.hasBeenRedirectedToConsent,
    );
    const { t } = useTranslation();
    const didomiObject = (window as any).Didomi;

    useEffect(() => {
        if (!hasBeenRedirectedToConsent) {
            didomiObject?.preferences?.show?.();
        }
    }, [didomiObject]);

    return (
        <div className="text-text-main-title relative flex h-screen w-screen flex-col overflow-x-hidden">
            <img
                alt="Ellipse"
                className="absolute top-0 h-[400px] w-[400px] select-none md:h-[600px] md:w-[600px]"
                src={Ellipse}
            />

            <img
                alt="Ellipse"
                className="absolute -right-32 bottom-0 h-[400px] w-[400px] select-none md:h-[600px] md:w-[600px]"
                src={Ellipse}
            />

            <main className="relative flex flex-col items-center pb-6">
                <div className="flex h-screen w-full items-center justify-center">
                    <div className="flex max-w-[500px] flex-col items-center gap-4 text-center">
                        <img
                            alt="Mailvista Logo"
                            className="mb-6 w-[400px]"
                            src={mailVistaLogo}
                        />
                        <h1 className="font-display text-3xl font-bold">
                            {t("askConsent.title")}
                        </h1>
                        <p className="mb-2 font-body">
                            {t("askConsent.subtitle")}
                        </p>
                        <p>{t("askConsent.text")}</p>
                        <Button
                            onClick={() => {
                                if (didomiObject) {
                                    didomiObject.preferences?.show?.();
                                }
                            }}
                            variant="purpleGradient"
                        >
                            {t("askConsent.button")}
                        </Button>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default AskConsent;
